<template>
    <div class="to-top-container" @click="handleClick" v-show="show">
        top
    </div>
</template>

<script>
import eventBus from '@/eventBus'
export default {
    data() {
        return {
            show: false
        }
    },
    mounted() {
        eventBus.$on('mainScroll', this.handleMainScroll);
        eventBus.$on('handleViewContainerScroll', this.handleBlogViewScroll);
        eventBus.$on('projectScroll', this.handleProjectScroll);
        eventBus.$on('messageScroll', this.handleMessageScroll)
    },
    beforeDestroy() {
        eventBus.$off('mainScroll', this.handleMainScroll);
        eventBus.$off('handleViewContainerScroll', this.handleBlogViewScroll);
        eventBus.$off('projectScroll', this.handleProjectScroll);
        eventBus.$off('messageScroll', this.handleMessageScroll)
    },
    methods: {
        handleClick() {
            eventBus.$emit('setScrollTop', 0)
        },
        handleMainScroll(dom) {
            if (!dom) {
                this.show = false;
                return
            }
            if (dom.scrollTop > 1000) {
                this.show = true
            } else {
                this.show = false
            }
        },
        handleBlogViewScroll(dom) {
            if (!dom) {
                this.show = false;
                return
            }
            if (dom.scrollTop > 550) {
                this.show = true
            } else {
                this.show = false
            }
        },
        handleProjectScroll(dom) {
            if (!dom) {
                this.show = false;
                return
            }
            if (dom.scrollTop > 1000) {
                this.show = true
            } else {
                this.show = false
            }
        },
        handleMessageScroll(dom) {
            if (!dom) {
                this.show = false;
                return
            }
            if (dom.target.scrollTop > 1000) {
                this.show = true
            } else {
                this.show = false
            }
        }
    }
}
</script>

<style lang="less" scoped>
.to-top-container {
    position: fixed;
    width: 50px;
    height: 50px;
    background: rgb(0, 0, 255);
    z-index: 999;
    right: 50px;
    bottom: 50px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    user-select: none;
}
</style>